import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import TitleBar from '../components/TitleBar.jsx';
import { 
    projectContext, loadingContext, urlValue, unfolder, openAlert, closeModalVw, openModalVw, encrypter, safeCloseModalVw, useTranslate, downloadFileNew,
    onImportExcelAsync, 
} from '../lib';
import { Alerts } from '../components/common/Alerts';
import SideBarGenAI from '../components/ProjectGenAI/SideBarGenAI';
import { useLocation, Link } from 'react-router-dom';
import DataTable from '../components/provider/datatable/Datatable';
import ArrowLeft from '../images/arrow-left-blue.svg';
import SearchIcon from '../images/search.svg';
import { useForm } from 'react-hook-form'
import Loading from '../components/Loading'
import SearchUser from '../components/SearchUser';
import SearchProject from '../components/SearchProject';
import SearchCampaign from '../components/SearchCampaign';
import SearchLob from '../components/SearchLob';
import NewUserStudio from '../components/NewUserStudio'
import NewUserClient from '../components/NewUserClient'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../components/common/ModalVw';
import emailValidator from 'email-validator';
import { SelectNesting } from '../components/common/Inputs/Select'
import DropdownMenu from '../components/common/DropdownMenu/DropdownMenu.jsx'
import UserRemoveMultipleAccess from '../components/UserRemoveMultipleAccess.jsx'
import 'react-tooltip/dist/react-tooltip.css';
import '../styles/settings.scss'
import '../styles/settingsOptions.scss'
import '../styles/styles.css'

const ProjectAccess = () => {
    const [selectedProject, setSelectedProject] = useContext(projectContext);
    const [loading, setLoading] = useContext(loadingContext);
    const [alert, setAlert] = useState({ title: '', visible: false, error: false });
    const [showUserSearch, setShowUserSearch] = useState(false);
    const [showProjectSearch, setShowProjectSearch] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [showModalSearch, setShowModalSearch] = useState(true);
    const location = useLocation();
    const isGenAI = location.pathname.includes('GenAI');
    const {t} = useTranslate();
    const [refresh, setRefresh] = useState(false)
    const [loadingUpload, setLoadingUpload] = useState(false)
    const [showCampaignSearch, setShowCampaignSearch] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [showLobSearch, setShowLobSearch] = useState(false);
    const [usersToRemoveAccess, setUsersToRemoveAccess] = useState([]);
    const [projectsToRemoveAccess, setProjectsToRemoveAccess] = useState([]);
    const [isModalOpenRemoveAccess, setIsModalOpenRemoveAccess] = useState(false);

    const campaignSearchResultsRef = React.useRef(null);

    const [isModalOpen, setIsModalOpen] = useState({
        new: false,
        typeUser: false,
        guest: false
    });
    const [selectedRadio, setSelectedRadio] = useState('TP');

    // For managing our selected items display
    const [selectedUsersList, setSelectedUsersList] = useState([]);
    const [selectedProjectsList, setSelectedProjectsList] = useState([]);

    const [showSummary, setShowSummary] = useState(false);

    const [assignToCampaign, setAssignToCampaign] = useState(false);
    const [assignToSubcampaign, setAssignToSubcampaign] = useState(false);
    const [selectedClient, setSelectedClient] = useState()
    const [showSearch, setShowSearch] = useState(false);
    const [userProjects, setUserProjects] = useState([]);

    const [isModalOpenUserStudio, setIsModalOpenUserStudio] = useState({
        delete: false,
        new: false,
        edit: false,
        delete_many: false
    })

    const [roleUser, setRoleUser] = useState(1)
    const [role, setRole] = useState(0)

    const menuOptions = [
        {
            id: 'remove-user-access',
            label: t('projectAccess.removeUserAccess'),
            icon: '👥',
            action: () => {
                setUsersToRemoveAccess([]);
                setProjectsToRemoveAccess([]);
                setIsModalOpenRemoveAccess(true);
                setTimeout(() => {
                openModalVw("#remove-access-md");
                }, 50);
            },
            divider: true
        },
    ];

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm()

    const userSearchResultsRef = React.useRef(null);
    const projectSearchResultsRef = React.useRef(null);
    const searchResultsContainerRef = React.useRef(null);

    const passwordValidator = (pwd) => (
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pwd)
    );

    useEffect(() => {
        setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    }, [refresh])

    useEffect(() => {
        if (selectedProjectsList.length === 0 && selectedCampaign) {
            setSelectedCampaign(null);
        }
    }, [selectedProjectsList.length]);

    useEffect(()=>{
        setSelectedCampaign(null);
    }, [])

    useEffect(() => {
        setSelectedUsers([]);
        setSelectedUsersList([]);
        setShowUserSearch(false);
    }, [selectedRadio]);

    const removeUserFromRemoveList = (userId) => {
        setUsersToRemoveAccess(usersToRemoveAccess.filter(user => user.id !== userId));
    };

    const removeProjectFromRemoveList = (projectId) => {
        setProjectsToRemoveAccess(projectsToRemoveAccess.filter(project => project.id !== projectId));
    };

    const handleRemoveAccess = async () => {
        if (usersToRemoveAccess.length === 0 || projectsToRemoveAccess.length === 0) {
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.selectUserAndProject') || 'Selecciona al menos un usuario y un proyecto', 
                    visible: true, 
                    error: true 
                }), 
                2000, 
                () => setAlert({ ...alert, visible: false })
            );
            return;
        }

        setLoading(true);
        const authData = checkLocalStorage();
        if (!authData) {
            setLoading(false);
            return;
        }

        let token = authData.token;
        let csrfToken = authData.csrfToken;
        let id = authData.id;

        try {
            const asClient = (u) => (u?.source === 'clients') || (u?.source == null && selectedRadio === 'TP');
            const asStudio = (u) => (u?.source === 'studio') || (u?.source == null && selectedRadio === 'Studio');

            const promises = [];
            let successCount = 0;
            let errorCount = 0;

            for (const user of usersToRemoveAccess) {
                for (const project of projectsToRemoveAccess) {
                    
                    // ========================================
                    // PARA CLIENTES (Client) -> clientProject
                    // ========================================
                    if (asClient(user)) {
                        console.log(`[REMOVE] CLIENT -> /studio/client-project/:id/delete | user=${user.ccms_name}(${user.id}) project=${project.name}(${project.id})`);
                        
                        promises.push(
                            axios({
                                method: 'get',
                                url: `${urlValue}/studio/client-project`,
                                headers: {
                                    user: id,
                                    'access-token': token,
                                    'X-CSRF-Token': csrfToken
                                },
                                withCredentials: true,
                            })
                            .then(response => {
                                const relation = response.data.find(value => 
                                    value.project_id === project.id && value.client_id === user.id
                                );
                                
                                if (relation) {
                                    // Eliminamos usando el endpoint correcto
                                    return axios({
                                        method: 'post',
                                        url: `${urlValue}/studio/client-project/${relation.id}/delete`,
                                        headers: {
                                            user: id,
                                            'access-token': token,
                                            'X-CSRF-Token': csrfToken
                                        },
                                        withCredentials: true,
                                    })
                                    .then(() => {
                                        successCount++;
                                        console.log(`✓ Cliente ${user.ccms_name} removido del proyecto ${project.name}`);
                                    })
                                    .catch(error => {
                                        errorCount++;
                                        console.error(`✗ Error removiendo cliente ${user.ccms_name} del proyecto ${project.name}:`, error);
                                    });
                                } else {
                                    console.warn(`⚠ No se encontró relación entre cliente ${user.ccms_name} y proyecto ${project.name}`);
                                }
                            })
                            .catch(error => {
                                errorCount++;
                                console.error(`✗ Error obteniendo relaciones clientProject:`, error);
                            })
                        );
                    } 
                    
                    // ========================================
                    // PARA USUARIOS STUDIO -> userProjects
                    // ========================================
                    else if (asStudio(user)) {
                        console.log(`[REMOVE] STUDIO -> /studio/user/user-project/access/delete | user=${user.ccms_name}(${user.id}) project=${project.name}(${project.id})`);
                        
                        promises.push(
                            axios({
                                method: 'post',
                                url: `${urlValue}/studio/user/user-project/access/delete`,
                                headers: {
                                    user: id,
                                    'access-token': token,
                                    'X-CSRF-Token': csrfToken
                                },
                                withCredentials: true,
                                data: {
                                    id: user.id,
                                    project: project.id
                                }
                            })
                            .then(() => {
                                successCount++;
                                console.log(`✓ Usuario Studio ${user.ccms_name} removido del proyecto ${project.name}`);
                            })
                            .catch(error => {
                                errorCount++;
                                console.error(`✗ Error removiendo usuario Studio ${user.ccms_name} del proyecto ${project.name}:`, error);
                            })
                        );
                    } else {
                        console.warn('⚠ Usuario sin tipo determinable, omitiendo:', user);
                    }
                }
            }

            await Promise.all(promises);
            
            setLoading(false);

            const totalExpected = usersToRemoveAccess.length * projectsToRemoveAccess.length;
            const message = errorCount > 0 
                ? `${successCount} accesos removidos correctamente. ${errorCount} fallaron.`
                : `${successCount} accesos removidos correctamente`;

            setUserProjects((prev) =>
                prev.filter(
                    (p) => !projectsToRemoveAccess.some((rem) => rem.id === p.id)
                )
            );    

            setProjectsToRemoveAccess([]);

            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: message,
                    visible: true,
                    error: errorCount > 0
                }), 
                3000, 
                () => {
                    setAlert({ ...alert, visible: false });
                }
            );

        } catch (error) {
            setLoading(false);
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.errorRemovingAccess') || 'Error al remover accesos', 
                    visible: true, 
                    error: true 
                }), 
                4000, 
                () => setAlert({ ...alert, visible: false })
            );
            console.error('Error general removiendo accesos:', error);
        }
    };

    const handleCloseRemoveMultipleAccess = () => {
        closeModalVw("#remove-access-md", () => {
            setIsModalOpenRemoveAccess(false);
            setUsersToRemoveAccess([]);
            setProjectsToRemoveAccess([]);
        });
    };

    const handleUserSelect = (user) => {
        
        setSelectedUsers(prev => {
            if (!prev.some(selectedUser => selectedUser.id === user.id)) {
                return [...prev, user];
            }
            return prev;
        });
    
        setSelectedUsersList(prev => {
            if (!prev.some(selectedUser => selectedUser.id === user.id)) {
                return [...prev, user];
            }
            return prev;
        });
        setShowUserSearch(false);
    };

    const handleProjectSelect = (project) => {
        if (!selectedProjects.some(selectedProject => selectedProject.id === project.id)) {
            setSelectedProjects(prev => [...prev, project]);
            setSelectedProjectsList(prev => [...prev, project]);
        }
        setShowProjectSearch(false);
    };

    const removeUser = (userId) => {
        setSelectedUsers(selectedUsers.filter(user => user.id !== userId));
        setSelectedUsersList(selectedUsersList.filter(user => user.id !== userId));
    };

    const removeProject = (projectId) => {
        setSelectedProjects(selectedProjects.filter(project => project.id !== projectId));
        setSelectedProjectsList(selectedProjectsList.filter(project => project.id !== projectId));
    };

    const getProjectRoute = (project) => {
        let new_route = project.type === 'GEN AI' ? `/${project.name}/UsersGenAI` : `/${project.name}/Users`
        return new_route;
    };

    // Batch assign access - multiple users to multiple projects
    const assignAccess = async () => {
        if (selectedUsers.length === 0 || selectedProjects.length === 0) {
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.selectOneUser'), 
                    visible: true, 
                    error: true 
                }), 
                1000, 
                () => setAlert({ ...alert, visible: false })
            );
            return;
        }

        setLoading(true);

        const authData = checkLocalStorage();
        if (!authData) return;

        let token = authData.token;
        let csrfToken = authData.csrfToken
        let id = authData.id;

        try {
            const asClient = (u) => (u?.source === 'clients') || (u?.source == null && selectedRadio === 'TP');
            const asStudio = (u) => (u?.source === 'studio')  || (u?.source == null && selectedRadio === 'Studio');

            const promises = [];
            for (const user of selectedUsers) {
                for (const project of selectedProjects) {
                    if (asClient(user)) {console.log(`[ASSIGN] CLIENT -> /studio/client-project | user=${user.ccms_name}(${user.id}) project=${project.name}(${project.id})`);
                        // CLIENT → /studio/client-project
                        promises.push(
                            axios({
                            method: 'post',
                            url: `${urlValue}/studio/client-project`,
                            headers: {
                                user: id,
                                'access-token': token,
                                'X-CSRF-Token': csrfToken
                            },
                            withCredentials: true,
                            data: {
                                project_id: project.id,
                                client_id: user.id,
                                assign_to_campaign_projects: assignToCampaign,
                                assign_to_subcampaign_projects: assignToSubcampaign,
                            },
                            })
                        );
                    } else if (asStudio(user)) {console.log(`[ASSIGN] STUDIO -> /studio/user/userproject | user=${user.ccms_name}(${user.id}) project=${project.name}(${project.id})`);
                        // STUDIO → /studio/user/userproject
                        const channel = 1;
                        const roleToUse = Number(roleUser) || 1;
                        promises.push(
                            axios({
                            method: 'post',
                            url: `${urlValue}/studio/user/userproject`,
                            headers: { 
                                user: id, 
                                'access-token': token,
                                'X-CSRF-Token': csrfToken
                            },
                            withCredentials: true,
                            data: {
                                id: user.id,
                                project: project.id,
                                channel: channel,
                                role: roleToUse,
                            },
                            })
                        );
                    } else {
                        console.warn('User sin tipo determinable, omitiendo:', user);
                    }
                }
            }

            await Promise.all(promises);
            
            setLoading(false);
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.accessGranted'), 
                    visible: true 
                }), 
                1000, 
                () => {
                    setAlert({ ...alert, visible: false });
                    setShowSummary(true);
                }
            );
            /*
            setSelectedUsers([]);
            setSelectedUsersList([]);
            setSelectedProjects([]);
            setSelectedProjectsList([]);
            */
        } catch (error) {
            setLoading(false);
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.errorAssigning'), 
                    visible: true, 
                    error: true 
                }), 
                4000, 
                () => setAlert({ ...alert, visible: false })
            );
            console.error('Error assigning access:', error);
        }
    };

    const startNewAssignment = () => {
        setSelectedUsers([]);
        setSelectedUsersList([]);
        setSelectedProjects([]);
        setSelectedProjectsList([]);
        setSelectedCampaign(null);
        setShowCampaignSearch(false);
        setShowSummary(false);
        setSelectedCampaign(null);
        setShowCampaignSearch(false);
    };

    const onSubmitDelete = () => {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        setLoading(true)
        axios({
          method: 'get',
          url: `${urlValue}/studio/client-project`,
          headers: {
            'access-token': token,
          },
        })
          .then(function (response) {
            const id = response.data.filter(value => {
              if (
                value.project_id === selectedProject.id &&
                value.client_id === selectedClient.id
              ) {
                return value
              }
            })[0].id
            axios({
              method: 'post',
              url: `${urlValue}/studio/client-project/${id}/delete`,
              headers: {
                'access-token': token,
              },
            })
              .then(function (response) {
                setLoading(false)
                setIsModalOpen({ ...isModalOpen, delete: false })
                setRefresh(!refresh)
              })
              .catch(function (error) {
                setLoading(false)
                setIsModalOpen({ ...isModalOpen, delete: false })
                setRefresh(!refresh)
              })
          })
          .catch(function (error) {
            setLoading(false)
            console.log(error)
          })
    }

    const checkLocalStorage = () => {
        try {
            if (!localStorage.getItem('hashUser') || !localStorage.getItem('hashInfo')) {
                openAlert('#alert-ac', 
                    () => setAlert({ 
                        title: t('alerts.authenticationError'), 
                        visible: true, 
                        error: true 
                    }), 
                    4000, 
                    () => setAlert({ ...alert, visible: false })
                );
                return false;
            }
            
            // Verificar que podemos hacer unfold
            const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
            let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
            const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
            
            if (!token || !id )  {
                throw new Error('Invalid token, csrfToken or id');
            }
            
            return { token, id, csrfToken };
        } catch (error) {
            console.error('Error checking localStorage:', error);
            openAlert('#alert-ac', 
                () => setAlert({ 
                    title: t('alerts.authenticationError'), 
                    visible: true, 
                    error: true 
                }), 
                4000, 
                () => setAlert({ ...alert, visible: false })
            );
            return false;
        }
    };

    const openProjectUsers = (project) => {
        try {
            localStorage.setItem('lastSelectedProject', encrypter(project, 'IANestingKey'));
        } catch (e) {
            const route = getProjectRoute(project);
            window.open(route, '_blank', 'noopener');
        };
    }

    const clearSelectedProjects = () => {
        setSelectedProjects([]);
        setSelectedProjectsList([]);
        setSelectedCampaign(null);
    };

    const userColumns = [
        {
            header: t('common.type'),
            field: 'source',
            width: '15%',
            render: (value) => (
            <div style={{ fontSize: 12 }}>
                {value === 'studio' ? 'Studio' : 'Client'}
            </div>
            )
        },
        {
            header: t('common.ntUser'),
            field: 'ccms_name',
            width: '60%',
            render: (value, user) => (
                <div style={{ fontSize: 14 }}>{value}</div>
            )
        },
        {
            header: t('common.bms'),
            field: 'ccms_id',
            width: '25%',
            render: (value) => (
                <div style={{ fontSize: 14 }}>{value}</div>
            )
        },
        {
            header: t('common.actions'),
            field: 'actions',
            width: '15%',
            align: 'center',
            render: (_, user) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src="/icons/trash.png"
                        alt="remove"
                        style={{ width: 15, cursor: 'pointer' }}
                        onClick={() => removeUser(user.id)}
                    />
                </div>
            )
        }
    ];

    const projectColumns = [
        {
            header: t('common.project'),
            field: 'name',
            width: '75%',
            render: (value, project) => (
                <div style={{ fontSize: 14 }}>{value}</div>
            )
        },
        {
            header: t('common.actions'),
            field: 'actions',
            width: '25%',
            align: 'center',
            render: (_, project) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src="/icons/trash.png"
                        alt="remove"
                        style={{ width: 15, cursor: 'pointer' }}
                        onClick={() => removeProject(project.id)}
                    />
                </div>
            )
        }
    ];

    if (showSummary) {
        const selectedClients = selectedUsersList.filter(
            u => u?.source === 'clients' || (u?.source == null && selectedRadio === 'TP')
        );
        const selectedStudios = selectedUsersList.filter(
            u => u?.source === 'studio' || (u?.source == null && selectedRadio === 'Studio')
        );

        return (
            <div className='general-container'>
                <TitleBar />
                <div>
                    <Link to={'/projects'} style={{margin: 0}} className='link_back_projects d-flex flex-row align-items-center'>
                        <img src={ArrowLeft} width={30} className='img_back_projects'></img>
                        <div style={{color: 'gray', fontSize: 12, marginLeft: 5}}>{t('menu.listOfProjects')}</div>
                    </Link>
                </div>
                <div className='primary-container d-flex flex-column' style={{ padding: '0 20px' }}>
                    <div className="title d-flex flex-row align-items-center mb-4 justify-content-between" style={{ whiteSpace: "nowrap" }}>
                        <h1 style={{fontSize: 16}}>{t('menu.projectAccessSummary')}</h1>
                        <div 
                            className="btn-top newProject" 
                            onClick={startNewAssignment}
                            style={{
                                backgroundColor: '#0B5FA3', 
                                color: 'white',
                                borderRadius: 10,
                                cursor: 'pointer',
                            }}
                        >
                            <div style={{padding: '5px 10px', fontSize: 12}}>{t('menu.newAssignments')}</div>
                        </div>
                    </div>

                    <div className="body pt-1 pb-3 account-container w-100 mb-4" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
                        <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15, padding: '15px 0 0 20px' }}>
                            {t('menu.usersWithAccess')} ({selectedUsersList.length})
                        </h2>
                        <div className="px-3 py-2">
                            <div className="user-summary-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {selectedUsersList.map(user => (
                                    <div key={user.id} style={{ 
                                        backgroundColor: 'white', 
                                        padding: '8px 12px', 
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <div>
                                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.ccms_name}</div>
                                            <div style={{ fontSize: '12px', color: '#666' }}>{t('common.id')}: {user.ccms_id}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="body pt-1 pb-3 account-container w-100 mb-4" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
                        <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15, padding: '15px 0 0 20px' }}>
                            {t('menu.projectsWithAccess')} ({selectedProjectsList.length})
                        </h2>
                        <div className="px-3 py-2">
                            <div className="project-summary-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {selectedProjectsList.map(project => (
                                    <div key={project.id} style={{ 
                                        backgroundColor: 'white', 
                                        padding: '8px 12px', 
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <a 
                                            href={getProjectRoute(project)}
                                            onClick={(e) => openProjectUsers(project, e)}
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{ 
                                                textDecoration: 'none', 
                                                color: '#0B5FA3',
                                                fontWeight: 'bold',
                                                fontSize: '14px'
                                            }}
                                        >
                                            {project.name}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="summary-details" style={{ 
                        backgroundColor: '#EAF2F8', 
                        padding: '15px', 
                        borderRadius: '10px',
                        marginBottom: '20px'
                    }}>
                        <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>{t('menu.projectAccessSummary')}</h3>
                        <p style={{ fontSize: '14px', marginBottom: '5px' }}>
                            <strong>{selectedUsersList.length}</strong> {t('menu.grantedAccess')} <strong>{selectedProjectsList.length}</strong>.
                        </p>
                        <p style={{ fontSize: '14px', color: '#666' }} className='mt-1'>
                            {t('menu.totalAccessPermisions')} <strong>{selectedUsersList.length * selectedProjectsList.length}</strong>
                        </p>
                        <p style={{ fontSize: '14px', color: '#666' }} className='mt-1'>
                            Clients → <strong>{selectedClients.length * selectedProjectsList.length}</strong> relations
                        </p>
                        <p style={{ fontSize: '14px', color: '#666' }} className='mt-1'>
                            Studio → <strong>{selectedStudios.length * selectedProjectsList.length}</strong> relations
                        </p>
                    </div>
                </div>
                {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
            </div>
        );
    }

    const openCreateUserByType = () => {
        setIsModalOpen({ new: false, typeUser: false, guest: false });

        if (selectedRadio === 'Studio') {
            setTimeout(() => {
            openModalVw("#adduser-studio", () =>
                setIsModalOpenUserStudio(prev => ({ ...prev, new: true }))
            );
            }, 50);
        } else if (selectedRadio === 'TP') {
            setTimeout(() => {
            openModalVw("#adduser-md", () =>
                setIsModalOpen(prev => ({ ...prev, new: true }))
            );
            }, 50);
        } else {
            setTimeout(() => {
            openModalVw("#guest-md", () =>
                setIsModalOpen(prev => ({ ...prev, guest: true }))
            );
            }, 50);
        }
    };

    const clearSelectedUsers = () => {
        setSelectedUsers([]);
        setSelectedUsersList([]);
        setShowUserSearch(false);
        setShowSummary(false);
    };

    return (
        <div className='general-container'>
            <TitleBar />
            <div>
                <Link to={'/projects'} style={{margin: 0}} className='link_back_projects d-flex flex-row align-items-center'>
                    <img src={ArrowLeft} width={30} className='img_back_projects'></img>
                    <div style={{color: 'gray', fontSize: 12, marginLeft: 5}}>{t('menu.listOfProjects')}</div>
                </Link>
            </div>
            <div className='primary-container d-flex flex-column' style={{ padding: '0 20px' }}>
                <div className="title d-flex flex-row align-items-center mb-4" style={{ whiteSpace: "nowrap", justifyContent: "space-between" }}>
                    <h1 style={{fontSize: 16}}>{t('menu.projectAccessManagement')}</h1>

                    <DropdownMenu 
                        options={menuOptions} buttonStyle={{marginTop: 10, fontSize: 11, textTransform: "uppercase"}}
                        buttonText={t('common.options') || 'Options'}
                        showButtonText={true}
                    />
                </div>

                <div className="body pt-1 pb-3 account-container w-100 mb-4" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
                    <div className='d-flex flex-row align-items-center justify-content-between'>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems:'center'}}>
                            <h2 className="pl-3" 
                                style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15, padding: '15px 0 0 20px', whiteSpace: 'nowrap' }}>
                                {t('menu.selectUsers')}
                            </h2>
                            <div className='ml-5 mt-2' style={{minWidth: 50}}>
                                <button 
                                    id="add-user-btn"
                                    onClick={() => setShowUserSearch(!showUserSearch)} 
                                >
                                    <img 
                                        src={SearchIcon} 
                                        style={{width: 20, height: 20, cursor: 'pointer'}} 
                                    />
                                    <Tooltip anchorSelect="#add-user-btn" content="Search for users to add" place="top" />
                                </button>
                            </div>
                        </div>
                        
                        <div className="d-flex flex-row px-3 pr-1 mb-3">
                            
                            <button
                                id="clear-projects-btn"
                                type="button"
                                onClick={clearSelectedUsers}
                                disabled={selectedUsersList.length === 0}
                                className="buttonE buttonH mr-3"
                                style={{ whiteSpace: 'nowrap', minWidth: 'auto', width: 'auto', opacity: selectedUsersList.length ? 1 : 0.6 }}
                                aria-label="Clear all selected users"
                            >
                                <span>{t('projectAccess.clearAllUsers')}</span>
                            </button>

                            <div className="flex flex-column">
                                <label htmlFor="typeuser-studio" className="flex flex-row items-center" style={{cursor: 'pointer', minWidth: 120}}>
                                    <input
                                        name="typeu"
                                        type="radio"
                                        id="typeuser-studio"
                                        checked={selectedRadio === "Studio"}
                                        onChange={() => setSelectedRadio("Studio")}
                                    />
                                    <span className="text-[#2E2E2E] ml-2">{t('projectAccess.tpUserStudio')}</span>
                                </label>
                                <label htmlFor="typeuser-client" className="flex flex-row items-center mt-1" style={{cursor: 'pointer'}}>
                                    <input
                                        name="typeu"
                                        type="radio"
                                        id="typeuser-client"
                                        checked={selectedRadio === "TP"}
                                        onChange={() => setSelectedRadio("TP")}
                                    />
                                    <span className="text-[#2E2E2E] ml-2">{t('projectAccess.tpUserClient')}</span>
                                </label>
                                {/*
                                <label htmlFor="typeuser-guest" className="flex flex-row items-center" style={{gap: 6, cursor: 'pointer'}}>
                                <input
                                    name="typeu"
                                    type="radio"
                                    id="typeuser-guest"
                                    checked={selectedRadio === "GUEST"}
                                    onChange={() => setSelectedRadio("GUEST")}
                                />
                                <Tooltip anchorSelect="#add-user-btn" content={t('menu.selectUsersTooltip')} place="top" />
                                <span className="text-[#2E2E2E] font-bold">Guest User</span>
                                </label>
                                */}
                            </div>


                            <button 
                                type="button"
                                id="create-user-btn" 
                                style={{
                                    whiteSpace: 'nowrap',
                                    minWidth: 'auto',
                                    width: 'auto',
                                }}
                                onClick={openCreateUserByType}
                                className='buttonE buttonH ml-2'
                            >

                                <span className='' style={{ color: 'white !important' }}>{t('menu.createUser')}</span>
                                <Tooltip anchorSelect="#create-user-btn" content={t('menu.createNewUser')} place="top" />
                            </button>

                        </div>
                    </div>
                    

                    <div id="user-search-results" ref={userSearchResultsRef} className="px-3 mb-3">
                        <SearchUser 
                            onUserSelect={handleUserSelect}
                            searchResultsContainer={userSearchResultsRef.current}
                            showSearch={showUserSearch}
                            setShowSearch={setShowUserSearch}
                            filterSource={selectedRadio === 'Studio' ? 'studio' : 'clients'}
                        />
                    </div>

                    <div className="px-3">
                        <DataTable
                            columns={userColumns}
                            data={selectedUsersList}
                            tableId="selected-users"
                            keyField="id"
                            emptyMessage={t('menu.noUserSelected')}
                            tableStyles={{ 
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}
                            headerStyles={{
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                                fontSize: '14px'
                            }}
                        />
                    </div>
                </div>

                <div className="body pt-1 pb-3 account-container w-100 mb-4" 
                    style={{ backgroundColor: '#F9F9F9', borderTop: '10px solid white' }}>
                    <div className='d-flex flex-row align-items-center justify-content-between'>
                        <div className='d-flex flex-row align-items-center'>
                            <h2 className="pl-3 mr-3" style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15, padding: '15px 0 0 20px', whiteSpace: 'nowrap' }}>
                                {t('menu.selectProjects')}
                            </h2>
                            <div 
                                id="add-project-btn" 
                                className="" style={{minWidth: 50}}
                                onClick={() => setShowProjectSearch(!showProjectSearch)} 
                            >
                                <img 
                                    src={SearchIcon} 
                                    style={{width: 20, height: 20, cursor: 'pointer'}} 
                                />
                                <Tooltip anchorSelect="#add-project-btn" content={t('menu.selectProjectsTooltip')} place="top" />
                            </div>
                        </div>
                        <div className="d-flex flex-row px-3 mb-3 pr-1">
                            <button
                                id="clear-projects-btn"
                                type="button"
                                onClick={clearSelectedProjects}
                                disabled={selectedProjectsList.length === 0}
                                className="buttonE buttonH mr-3"
                                style={{ whiteSpace: 'nowrap', minWidth: 'auto', width: 'auto', opacity: selectedProjectsList.length ? 1 : 0.6 }}
                                aria-label="Clear all selected projects"
                            >
                                <span>{t('projectAccess.clearAllProjects')}</span>
                            </button>

                            <button
                                type="button"
                                onClick={() => {
                                    setShowCampaignSearch((prev) => !prev);
                                    setShowProjectSearch(false);
                                }} style={{
                                    whiteSpace: 'nowrap',
                                    minWidth: 'auto',
                                    width: 'auto',
                                }}
                                aria-label="Search Campaign" className='buttonE buttonH'
                                >
                                <span>{t('projectAccess.selectByCampaign')}</span>
                            </button>

                            <button
                                type="button"
                                onClick={() => {
                                    setShowLobSearch((prev) => !prev);
                                    setShowProjectSearch(false);
                                    setShowCampaignSearch(false);
                                }}
                                style={{
                                    whiteSpace: 'nowrap',
                                    minWidth: 'auto',
                                    width: 'auto',
                                }}
                                aria-label="Search LOB"
                                className='buttonE buttonH ml-3'
                            >
                                <span>{t('projectAccess.selectByLoB')}</span>
                            </button>
                        </div>
                    </div>

                    <div id="project-search-results" ref={projectSearchResultsRef} className="px-3 mb-3">
                        <SearchProject 
                            onProjectSelect={handleProjectSelect}
                            searchResultsContainer={projectSearchResultsRef.current}
                            showSearch={showProjectSearch}
                            setShowSearch={setShowProjectSearch}
                        />
                    </div>

                    <div id="campaign-search-results" className="px-3 mb-3">
                        <SearchCampaign
                            onCampaignSelect={({ campaign, projects }) => {
                                setSelectedCampaign(campaign);
                                // mostrar los proyectos de la campaña debajo del badge de campaña
                                setSelectedProjectsList((prev) => {
                                const key = (p) => String(p?.id ?? p?.name);          // fallback por name
                                    const seen = new Set(prev.map(key));
                                    const clean = projects.filter(p => p && p.id && p.name);
                                    const toAdd = clean.filter(p => !seen.has(key(p)));

                                    return [...prev, ...toAdd];
                                });
                                // también marcar “seleccionados” para el enrolamiento
                                setSelectedProjects((prev) => {
                                    const key = (p) => String(p?.id ?? p?.name);
                                    const seen = new Set(prev.map(key));
                                    const clean = projects.filter(p => p && p.id && p.name);
                                    const toAdd = clean.filter(p => !seen.has(key(p)));
                                    return [...prev, ...toAdd];
                                });
                            }}
                            searchResultsContainer={campaignSearchResultsRef}
                            showSearch={showCampaignSearch}
                            setShowSearch={setShowCampaignSearch}
                        />
                    </div>

                    {showLobSearch && (
                        <SearchLob
                            onLobSelect={({ subCampaign, projects }) => {
                            setSelectedCampaign(subCampaign);
                            setSelectedProjectsList(projects);
                            setShowLobSearch(false);
                            }}
                            showSearch={showLobSearch}
                            setShowSearch={setShowLobSearch}
                        />
                    )}

                    <div className="px-3">
                        {selectedCampaign && (
                            <div style={{ 
                                background:'#EEF6FF', border:'1px solid #CFE3FF', borderRadius:10, padding:12, marginBottom:15 
                            }}>
                                <div style={{fontSize:12, color:'#0B5FA3', textTransform:'uppercase', letterSpacing:.3}}>
                                {t('projectAccess.campaignSelected')}
                                </div>
                                <div style={{fontWeight:700, fontSize:16}}>{selectedCampaign.name}</div>
                                <div style={{fontSize:12, color:'#666'}}>ID: {selectedCampaign.id}</div>
                                <div ref={campaignSearchResultsRef} />
                            </div>
                        )}
                        <DataTable
                            columns={projectColumns}
                            data={selectedProjectsList}
                            tableId="selected-projects"
                            keyField="id"
                            emptyMessage={t('menu.noProjectSelected')}
                            tableStyles={{ 
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}
                            headerStyles={{
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                                fontSize: '14px'
                            }}
                        />
                    </div>
                </div>

                <div className="d-flex flex-row w-100 pb-2" style={{justifyContent: 'flex-end', gap: 16, alignItems: 'center'}}>
                    <button 
                        type="button"
                        id="grant-access-btn" 
                        className="buttonF buttonH"
                        onClick={assignAccess}
                        style={{
                            whiteSpace: 'nowrap',
                            minWidth: 'auto',
                            width: 'auto',
                        }}
                    >
                        <span style={{ color: 'white !important' }}>{t('menu.grantAccess')}</span>
                        <Tooltip anchorSelect="#grant-access-btn" content={t('menu.grantAccessTooltip')} place="top" />
                    </button>
                </div>

                {isModalOpen.new &&
                <ModalVw id="adduser-md" visible={isModalOpen.new} className="z-[500]" style={{maxWidth: 1100, margin: 'auto'}}>
                    <ModalContent clases={`w-100  bg-white`}>
                        <ModalHeader title="" onClose={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))} />
                        <ModalBody clases={``} >
                            <NewUserClient isModalOpen={isModalOpenUserStudio} 
                                closeModal={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))}
                                selectedProject = {selectedProject}
                                closeFunction={(newUser) => { 
                                    if (newUser && newUser?.id) {
                                        handleUserSelect({
                                            id: newUser.id,
                                            ccms_id: newUser.ccms_id,
                                            ccms_name: newUser.ccms_name,
                                            source: 'clients'
                                        });
                                        
                                        closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }));
                                    }
                                }}
                                associateToProject={false}
                            />
                        </ModalBody>
                    </ModalContent>
                </ModalVw>}

                {/* Agregar usuarios de Studio */}
                {isModalOpenUserStudio.new &&
                <ModalVw id="adduser-studio" visible={isModalOpenUserStudio.new} className="z-[500]">
                    <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
                    <ModalHeader title="" onClose={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false }))} />
                    <ModalBody clases={``} >
                    <NewUserStudio isModalOpen={isModalOpenUserStudio} 
                        closeModal={() => { closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false }))} }
                        closeFunction={(newUser) => { 
                            console.log("newUser", newUser)

                            handleUserSelect({
                                id: newUser.id,
                                ccms_id: newUser.ccms_id,
                                ccms_name: newUser.ccms_name,
                                source: 'studio'
                            });
                        }}
                        associateToProject={false}
                        />
                    </ModalBody>
                    </ModalContent>
                </ModalVw>}
                
                {/* Eliminar usuarios de client */}
                {isModalOpen.delete &&
                <ModalVw id="deleteuser-md" visible={isModalOpen.delete}  >
                    <ModalContent clases={` sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
                    <ModalHeader title="" onClose={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))} />
                    <ModalBody clases={``} >
        
        
                        {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
                        <div id="container-modal" className='modal-c'>
                        <img src="/icons/alert.png" alt="" />
                        <h1>{t('projectAccess.deleteUserTitle')}</h1>
                        <h1>{t('projectAccess.deleteUserQuestion')}</h1>
                        <div className="buttons-modal">
                            <button
                            onClick={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))}
                            className="cancel btn-modal-cancel"
                            >
                            {t('projectAccess.cancel')}
                            </button>
                            <button onClick={onSubmitDelete} className="accept">
                            {t('projectAccess.yes')}
                            </button>
                        </div>
                        </div>
                        {/* </Modal> */}
        
                    </ModalBody>
                    </ModalContent>
                </ModalVw>}

                <UserRemoveMultipleAccess
                    isOpen={isModalOpenRemoveAccess}
                    onClose={handleCloseRemoveMultipleAccess}
                    usersToRemoveAccess={usersToRemoveAccess}
                    projectsToRemoveAccess={projectsToRemoveAccess}
                    setUsersToRemoveAccess={setUsersToRemoveAccess}
                    setProjectsToRemoveAccess={setProjectsToRemoveAccess}
                    selectedRadio={selectedRadio}
                    setSelectedRadio={setSelectedRadio}
                    onConfirmRemoveAccess={handleRemoveAccess}
                    checkLocalStorage={checkLocalStorage}
                    userProjects={userProjects}
                    setUserProjects={setUserProjects}
                />
                
                {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
            </div>
        </div>
    );
};

export default ProjectAccess;